import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function symbolValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const symbolPass = control.value

    const symbol = /[.,\/#!@$%+^&*;:{}=\-_`~(){}|<>№'"?\[\]\\]/

    if (!symbol.test(symbolPass)) {
      return {'symbolNotValid': true}
    }

    return null;

  }
}
